import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/clientes/clientes.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import EditClientes from './EditCliente.template';
import { SelectChangeEvent } from '@mui/material';

const api = useApi();

export default function Cliente() {
  const { setLoading, setLoadingMensagem, setLoadingBtn, setClearLoading }: any = useContext(LoadingContext);

  const [clientes, setClientes] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [cli, setCli] = useState();
  const [edit, setEdit] = useState<boolean>(false);
  const [allClientes, setAllClientes] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>(
    table.header.filter((column) => !['Editar', 'Excluir'].includes(column)),
  );
  //Parte do modal delete
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  //Parte do modal delete
  const handleExcluir = (row: string) => {
    setPath('/cliente/');
    setItemExclude(row);
    setOpen(true);
  };

  const getAllClientes = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/cliente?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/cliente?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllClientes(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    console.log('Colunas do selectedFilterColumns:' + selectedFilterColumns);
    console.log('Colunas do table header:' + table.header);
    api
      .get(
        '/cliente' +
          `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
      )
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Erro ao carregar página.');
          setLoadingBtn('OK');
          return;
        }
        setClearLoading();
        setClientes(response.results);
        setPageTotal(response.page_total);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllClientes();
  }, [page, like, selectedFilterColumns]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleEditar = (row: any) => {
    setCli(row);
    setEdit(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: row?.endereco || '-', onClick: null, link: false },
          { campo: row?.cpfCNPJ || '-', onClick: null, link: false },
          { campo: row?.estado || '-', onClick: null, link: false },
          { campo: row?.telefone || '-', onClick: null, link: false },
          { campo: row?.whatsapp || '-', onClick: null, link: false },
          { campo: row?.vendedor?.nome || '-', onClick: null, link: false },
          { campo: 'Editar', onClick: () => handleEditar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(clientes),
  };
  const arrListAll = {
    header: table.header,
    type: table.type,
    rows: formataTable(allClientes),
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem('selectedFilterColumns');
    if (savedColumns) {
      const filteredColumns = JSON.parse(savedColumns).filter((column) => table.header.includes(column));
      setSelectedFilterColumns(filteredColumns);
    }
  }, []);

  const handleFilterColumnsChange = (event: SelectChangeEvent<string[]>) => {
    const filteredColumns = event.target.value as string[];
    const updatedFilterColumns = filteredColumns.filter(
      (column) => table.header.includes(column) && !['Editar', 'Excluir'].includes(column),
    );
    setSelectedFilterColumns(updatedFilterColumns);
    localStorage.setItem('selectedFilterColumns', JSON.stringify(updatedFilterColumns));
  };

  return (
    <>
      {!edit && (
        <ComponenteTables
          table={arrList}
          cadastro={cadastro}
          pageTotal={pageTotal}
          page={page}
          handleChangePage={handleChangePage}
          handleLike={handleLike}
          path={path} // path  do delete
          itemExclude={itemExclude} // id do item
          open={open} // abre modal delete
          setOpen={setOpen} // controle modal delete
          allData={arrListAll}
          selectedFilterColumns={selectedFilterColumns}
          handleFilterColumnsChange={handleFilterColumnsChange}
        />
      )}
      {edit && <EditClientes dado={cli} setEdit={() => setEdit(false)} />}
    </>
  );
}
